import PlayerFormModal from "./PlayerFormModal"

export function NewPlayerModal({ closeModal }) {
	return <PlayerFormModal mode="new" closeModal={closeModal} />
}

export default NewPlayerModal
